import * as React from 'react';
import Reaptcha from 'reaptcha';

export default function Recaptcha(props) {
  return (
    <div className="row justify-content-center">
      <div className="col-10 col-lg-8 m-2">
        <Reaptcha
          ref={props.recaptchaRef}
          id="reaptcha"
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
          onVerify={props.setRecaptcha}
        />
        {props.recaptcha === false && <label htmlFor="reaptcha">Ezt a mezőt kötelező bepipálni!</label>}
      </div>
    </div>
  );
}
